import Select from 'react-select';

import { getStyles } from '../helpers/random-form-helpers';

const ReactSelect = ({
  field,
  form,
  options,
  isMulti = false,
  placeholder = 'Select',
  onInputChange,
  isLoading,
  disabled,
  onChange,
  ...rest
}) => {
  const getValue = () => {
    if (options.length) {
      return isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    } else {
      return isMulti ? [field.value] : field.value;
    }
  };

  const customStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 9999, // ensures dropdown appears above siblings
      position: 'absolute',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '0.8rem', // change this value to the desired font size
      backgroundColor: state.isFocused ? '#DCE7F5' : '#FFFFFF',
      color: '#000000',
    }),
  };

  if (!isMulti) {
    return (
      <Select
        classNamePrefix="react-select"
        menuPosition="absolute"
        styles={customStyles}
        options={options}
        name={field.name}
        isLoading={isLoading}
        className={
          form?.touched[field.name] && getStyles(form?.errors, field.name)
            ? 'react-select-container error'
            : 'react-select-container'
        }
        value={getValue()}
        onChange={(option) => {
          if (onChange) {
            onChange(option);
          }
          if (form?.setFieldValue) form.setFieldValue(field.name, option.value);
        }}
        onInputChange={onInputChange}
        onBlur={() => {
          if (form?.handleBlur)
            form.handleBlur({ target: { name: field.name } });
        }}
        placeholder={placeholder}
        isDisabled={disabled}
        isClearable
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#033272',
          },
        })}
        {...rest}
      />
    );
  } else {
    return (
      <Select
        classNamePrefix="react-select"
        className={
          form?.touched[field.name] && getStyles(form?.errors, field.name)
            ? 'react-select-container error'
            : 'react-select-container'
        }
        name={field.name}
        value={getValue()}
        styles={customStyles}
        onChange={(option) => {
          form.setFieldValue(
            field.name,
            option ? option.map((item) => item.value) : []
          );
        }}
        options={options}
        menuPosition="absolute"
        isMulti={true}
        onBlur={() => {
          if (form?.handleBlur)
            form.handleBlur({ target: { name: field.name } });
        }}
        placeholder={placeholder}
        isDisabled={disabled}
        {...rest}
      />
    );
  }
};

export default ReactSelect;
